import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { configureAmplify } from './amplify'
import { GoogleTagManager } from './components/GoogleTagManager'
import { loadAppConfig } from './lib/app-config'
import './index.css'
import './i18n'

async function bootstrap() {
  const config = await loadAppConfig()
  configureAmplify(config)

  const { default: App } = await import('./App')

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <GoogleTagManager />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  )
}

void bootstrap()
